var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation-errors"},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"validation-error-item"},[_vm._v(_vm._s(error))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }